/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {WinPresentationController} from "../WinPresentationController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TimelineLite} from "gsap";
import {DeadwoodRip} from "../../DeadwoodRip";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DeadwoodRipS1Symbol} from "../../symbol/DeadwoodRipS1Symbol";
import {DeadwoodRipS2Symbol} from "../../symbol/DeadwoodRipS2Symbol";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin():boolean {
        const data = DeadwoodRip.model.parsedGameData;
        return data.mode === GameMode.NORMAL && data.nextMode != GameMode.NORMAL;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = new TimelineLite();
        tl.add(() => {
            // DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.FREE_SPIN_WIN});
            // DeadwoodRip.background.updateMode(DeadwoodRip.model.data.nextMode);
            // DeadwoodRip.xBetController.featureVisible = false;
            DeadwoodRip.initialCountUp.remove();
            DeadwoodRip.bigWinCountUp.remove();
            DeadwoodRip.waysWon.remove();
            SlotGame.keypadPlugin.hide();
        });

        if(DeadwoodRip.playScattersWin) {
            DeadwoodRip.model.parsedGameData.S1Positions!.forEach((symId, reelId) => {
                if(symId > -1) {
                    const symbol = <DeadwoodRipS1Symbol>DeadwoodRip.reels[reelId].getSymbol(symId);
                    tl.add([
                        () => {
                            DeadwoodRip.reels[reelId].reelView.addWinSymbol(symbol);
                        },
                        symbol.playWin(false)
                    ], 0);
                }
            });
            if(DeadwoodRip.model.parsedGameData.doXSplit) {
                const s2 = <DeadwoodRipS2Symbol>DeadwoodRip.reels[4].getSymbol(0);
                tl.add([
                    () => {
                        DeadwoodRip.reels[4].reelView.addWinSymbol(s2);
                        DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S2_WIN});
                    },
                    s2.playWinSuper()
                ], 1.2);
            }
            tl.add(() => {
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S1_WIN});
            }, 0);

        }
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            DeadwoodRip.freespinIntro.show(() => {
                SlotGame.keypadPlugin.setZeroBetSpinCounter(DeadwoodRip.model.parsedGameData.freespinsLeft);
                resolve();
            });
        });
    }
}